import { render, staticRenderFns } from "./FeedbackRate.vue?vue&type=template&id=8a34c1ec&scoped=true&"
import script from "./FeedbackRate.vue?vue&type=script&lang=js&"
export * from "./FeedbackRate.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackRate.vue?vue&type=style&index=0&id=8a34c1ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a34c1ec",
  null
  
)

export default component.exports